import { useState } from 'react';
import { ScanLine } from 'lucide-react';

import { Can } from '@/auth/guards';
import { PERMISSIONS } from '@/auth/permissions';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { CartPanel } from '@/features/billing/CartPanel';
import { MedicineSearch } from '@/features/billing/MedicineSearch';
import { PrescriptionScanDialog } from '@/features/billing/PrescriptionScanDialog';
import { useCart } from '@/features/billing/cartStore';

/**
 * The counter screen. Search fills most of the space since that's where a
 * pharmacist's attention lives while a queue is waiting; the cart docks to
 * the side on a counter tablet and below the fold on a phone.
 */
export function BillingPage() {
  const cart = useCart();
  const [scanOpen, setScanOpen] = useState(false);

  return (
    <div className="flex h-[calc(100vh-8.5rem)] flex-col gap-4 lg:flex-row">
      <div className="flex min-h-0 flex-1 flex-col gap-2">
        <Can permission={PERMISSIONS.ocrUse}>
          <Button type="button" variant="outline" size="sm" className="self-start" onClick={() => setScanOpen(true)}>
            <ScanLine className="h-3.5 w-3.5" /> Scan prescription
          </Button>
        </Can>
        <div className="min-h-0 flex-1">
          <MedicineSearch />
        </div>
        <PrescriptionScanDialog open={scanOpen} onOpenChange={setScanOpen} />
      </div>

      <Card className="flex min-h-0 shrink-0 flex-col overflow-hidden lg:w-96">
        <div className="flex items-center justify-between border-b border-border px-4 py-3">
          <h2 className="text-sm font-semibold">Current bill</h2>
          {cart.items.length > 0 && (
            <span className="tabular text-xs text-muted-foreground">
              {cart.items.length} item(s)
            </span>
          )}
        </div>
        <div className="min-h-0 flex-1">
          <CartPanel />
        </div>
      </Card>
    </div>
  );
}